import { ReportView } from "@components/organisms";
import React from "react";

import { useAppSelector } from "@store";

const ResultPage = () => {
  const analyzedData = useAppSelector((state) => state.data.analyzedData);

  return (
    <div className="pt-[0px] px-[20px] pb-[30px]">
      <ReportView analyzedData={analyzedData} />
    </div>
  );
};

export default ResultPage;
